// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(partnerLoginStatus) {
  switch (partnerLoginStatus) {
    case "offline" :
        return /* Offline */1;
    case "online" :
        return /* Online */0;
    default:
      return ErrorUtils$Catalyst.raiseError("LoginStatus.re", "Invalid 'partnerLoginStatus' ", partnerLoginStatus);
  }
}

function toString(partnerLoginStatus) {
  if (partnerLoginStatus) {
    return "offline";
  } else {
    return "online";
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

var lst = {
  hd: /* Online */0,
  tl: {
    hd: /* Offline */1,
    tl: /* [] */0
  }
};

export {
  fromString ,
  toString ,
  t_decode ,
  lst ,
  
}
/* No side effect */
